<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2024-05-07 09:14:16
 * @LastEditors: whaoo
 * @LastEditTime: 2024-05-07 10:25:02
-->
<template>
  <div class="layout">
    <div class="layout_left">
      <!-- <div class="logo_box">
        <img src="../../assets/sidebar_logo.png" alt @click="logout" />
      </div> -->
      <Sidebar></Sidebar>
    </div>
    <div class="layout_right">
      <HeaderTop class="header_top"></HeaderTop>
      <AppMain class="app_main"></AppMain>
    </div>
    <el-dialog :visible.sync="logoutDialog" title="退出登录" width="580px">
      <div class="logout">
        <i class="el-icon-warning el-icon-iconName " color="#e6a23c"></i><span>是否注销账户，重新登录？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="logoutDialog = false">取 消</el-button>
        <el-button type="primary" @click="logoutConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sidebar from "./sidebar.vue";
import HeaderTop from "./headertop.vue";
import AppMain from "./appmain.vue";
export default {
  components: { Sidebar, HeaderTop, AppMain },
  data() {
    return {
      logoutDialog: false
    };
  },

  mounted() { },

  methods: {
    logout() {
      this.logoutDialog = true
    },
    logoutConfirm() {
      localStorage.clear()
      this.$router.push('/login')
    }
  },
};
</script>
<style scoped>
.layout {
  width: 100%;
  display: flex;
  height: 100vh;
  background-color: #d5eaff;
}

.layout_left {
  width: 310px;
  position: relative;
}

.layout_right {
  width: calc(100% - 310px);
  background-color: #fff;
  border-top-left-radius: 20px;
}

.header_top {
  height: 88px;
}

.app_main {
  height: calc(100% - 88px);
  overflow: auto;
}

.app_main::-webkit-scrollbar {
  width: 0px;
}

.logo_box {
  width: 100%;
  height: 88px;
  display: flex;
  align-items: center;
}

.logo_box img {
  width: 155px;
  margin-left: 40px;
}
.logout{
    height: 146px;
    line-height: 146px;
    color: #e6a23c;
    display: flex;
    align-items: center;
    justify-content: center;
}
.logout span{
    color: #636676;
    margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/view/layout/layout.vue